import { axios } from "../../../../../utils/settings";
import * as Sentry from '@sentry/react';
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { annualTripDetailsUrl } from "../urls";

export const getAnnualTripDetails = async (manufacturer_id, company_esi_id) => {
  try {
    const token = await getToken();
    const { data } = await axios.get(
      `${annualTripDetailsUrl()}?manufacturer_id=${manufacturer_id}&company_esi_id=${company_esi_id}`,
      getTokenHeader(token),
    );
    return data;
  } catch (err) {
    Sentry.captureException(err, {
      tags: { module: 'benefits', flow: 'getAnnualTripDetails' },
    });
    return { error: true, message: err.response?.data?.message || err.message };
  }
};
